import RamForm from 'forms/ftacabatsrequest/ramCompare'
import PropTypes from 'prop-types'

export default function RamsVersion1({
  ramTab,
  setRamTab,
  side,
  isAnswered,
  valuesBefore,
  valuesAfter
}) {
  const ramNumbers = valuesAfter
    ?.map((ram) => Number(ram.RamNumber))
    ?.filter((v) => !isNaN(v))
    ?.sort((a, b) => a - b)

  const compareRams = (x) => {
    const requestRam = valuesBefore?.find((ram) => ram.RamNumber === x)
    const historyRamKeys = Object.keys(requestRam.HistoryRam)
    let isDifferent = false
    let i = 0

    while (i < historyRamKeys.length && !isDifferent) {
      const key = historyRamKeys[i]

      if (
        key !== 'RequestRamId' &&
        key !== 'HistoryRamId' &&
        key !== 'RamId' &&
        key !== 'RamNumber' &&
        key !== 'Article'
      ) {
        if (requestRam.HistoryRam[key] !== requestRam[key]) {
          isDifferent = true
        }
      }

      i++
    }

    return isDifferent ? (
      <>
        <a
          className={`${
            side === 'left'
              ? 'hover:bg-red-600 border-red-600'
              : isAnswered
              ? 'hover:bg-emerald-600 border-emerald-600'
              : 'hover:bg-amber-600 border-amber-600'
          } relative w-20 lg:w-24 border-2 transition duration-300 rounded text-md uppercase hover:text-white font-ms-bold py-2.5 text-center inline-flex items-center justify-center
                  ${
                    ramTab === x
                      ? `text-white ${
                          side === 'left'
                            ? 'bg-red-600'
                            : isAnswered
                            ? 'bg-emerald-600'
                            : 'bg-amber-600'
                        }`
                      : `${
                          side === 'left'
                            ? 'text-red-600'
                            : isAnswered
                            ? 'text-emerald-600'
                            : 'text-amber-600'
                        } bg-white`
                  }
                `}
          onClick={(e) => {
            e.preventDefault()
            setRamTab(x)
          }}
          data-toggle="tab"
          href={`#link${x}`}
          role="tablist"
        >
          RAM {x}
          <span
            className={`w-4 h-4 ${
              side === 'left'
                ? 'bg-red-600'
                : isAnswered
                ? 'bg-emerald-600'
                : 'bg-amber-600'
            } p-0.5 rounded-full absolute left-auto -top-1.5 -right-1.5 border-2 border-white`}
          ></span>
        </a>
      </>
    ) : (
      <a
        className={`${
          side === 'left'
            ? 'hover:bg-gray-400 border-gray-400'
            : 'hover:bg-blue-300 border-blue-300'
        } w-20 lg:w-24 border-2 transition duration-300 rounded text-md uppercase hover:text-white font-ms-bold py-2.5 text-center inline-flex items-center justify-center
              ${
                ramTab === x
                  ? `text-white ${
                      side === 'left' ? 'bg-gray-400' : 'bg-blue-300'
                    }`
                  : `${
                      side === 'left' ? 'text-gray-400' : 'text-blue-300'
                    } bg-white`
              }
            `}
        onClick={(e) => {
          e.preventDefault()
          setRamTab(x)
        }}
        data-toggle="tab"
        href={`#link1${x}`}
        role="tablist"
      >
        RAM {x}
      </a>
    )
  }

  return (
    <div
      className={`flex flex-col col-span-6 bg-white border-2 border-collapse ${
        side === 'left' ? 'border-gray-300' : 'border-blue-200'
      } rounded shadow-md print:shadow-none`}
    >
      <div
        className={`flex items-center justify-between w-full px-2 py-2 text-sm uppercase ${
          side === 'left' ? 'bg-gray-300' : 'bg-blue-200'
        } print:py-1 font-ms-bold`}
      >
        <span>REGLATGES RAM</span>
      </div>

      <div className="flex flex-wrap w-full p-2">
        <ul
          className="grid w-full grid-cols-1 gap-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
          role="tablist"
        >
          {/* Mostrar botones rams: */}
          {ramNumbers?.map((ramNumber) => (
            <li
              key={ramNumber}
              className="relative flex-auto col-span-1 text-center"
            >
              {compareRams(ramNumber)}
            </li>
          ))}
        </ul>

        <div className="relative flex flex-col w-full min-w-0 p-2 break-words bg-white">
          <div className="tab-content tab-space">
            {/* Mostrar contenido rams: */}
            {ramNumbers?.map((ramNumber) => (
              <div
                key={ramNumber}
                className={ramTab === ramNumber ? 'grid' : 'hidden'}
                id={`link${ramNumber}`}
              >
                <RamForm
                  ramNumber={ramNumber}
                  ramIndex={
                    side === 'left'
                      ? valuesBefore?.findIndex(
                          (ram) => Number(ram.RamNumber) === ramNumber
                        )
                      : valuesAfter?.findIndex(
                          (ram) => Number(ram.RamNumber) === ramNumber
                        )
                  }
                  side={side}
                  isAnswered={isAnswered}
                  valuesBefore={valuesBefore}
                  valuesAfter={valuesAfter}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

RamsVersion1.propTypes = {
  ramTab: PropTypes.number,
  setRamTab: PropTypes.func,
  side: PropTypes.string.isRequired,
  isAnswered: PropTypes.bool,
  valuesBefore: PropTypes.array,
  valuesAfter: PropTypes.array
}
